module.exports = __webpack_public_path__ + "static/media/navbar_logo.a2952970.jpg";